import useApp from "hooks/useApp";
import { Navigate, Outlet } from "react-router-dom";

export const AuthGuard = () => {
  const { isLoggedIn } = useApp();

  let content;

  if (isLoggedIn === "loggedIn") {
    content = <Outlet />;
  } else {
    content = <Navigate to="/auth" />;
  }

  return content;
};
